// Built-in starter recipes shown on first run (no saved data yet). Ported
// as-is from WEEKLY_2.HTM.
import { uid } from "./utils";

// Used only to identify the app's original built-in recipes when migrating
// previously-saved data that predates the source/favorite fields.
export const SEED_TITLES = [
  "Weeknight chicken stir-fry",
  "Lentil soup",
  "Sheet-pan salmon and veg",
  "Weekend pancakes",
  "Simple green salad",
  "Apple slices with peanut butter",
];

const RAW_SEED_RECIPES = [
  {
    id: uid(), title: "Weeknight chicken stir-fry", cuisine: "Chinese", source: "Generic Seeding", favorite: false, mealTypes: ["dinner"], recipeType: "entree",
    dietTags: [], seasons: [], cookingMethod: [], yield: "", activeTime: 15, cookTime: 10, servings: 4, caloriesPerServing: 480, proteinPerServing: 34, carbsPerServing: 48, fatPerServing: 14,
    ingredients: [
      { id: uid(), component: "", name: "chicken thighs", prep: "diced", quantity: "500", unit: "g", category: "protein" },
      { id: uid(), component: "", name: "broccoli", prep: "chopped", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "garlic", prep: "minced", quantity: "3", unit: "clove", category: "produce" },
      { id: uid(), component: "", name: "soy sauce", prep: "", quantity: "3", unit: "tbsp", category: "pantry" },
      { id: uid(), component: "", name: "rice", prep: "", quantity: "2", unit: "cup", category: "bulk" },
    ],
    instructions: [
      "Cook rice according to package instructions.",
      "Heat a wok or large skillet over high heat, add a little oil, and stir-fry the chicken until browned.",
      "Add garlic and broccoli, stir-fry 2-3 minutes until broccoli is bright green.",
      "Add soy sauce, toss to coat, and cook another minute.",
      "Serve over rice.",
    ],
  },
  {
    id: uid(), title: "Lentil soup", cuisine: "Mediterranean", source: "Generic Seeding", favorite: false, mealTypes: ["dinner"], recipeType: "entree",
    dietTags: ["vegan", "vegetarian", "glutenFree"], seasons: ["Fall", "Winter"], cookingMethod: [], yield: "", activeTime: 10, cookTime: 30, servings: 4, caloriesPerServing: 320, proteinPerServing: 18, carbsPerServing: 52, fatPerServing: 4,
    ingredients: [
      { id: uid(), component: "", name: "red lentils", prep: "rinsed", quantity: "300", unit: "g", category: "bulk" },
      { id: uid(), component: "", name: "carrots", prep: "diced", quantity: "2", unit: "", category: "produce" },
      { id: uid(), component: "", name: "onion", prep: "diced", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "garlic", prep: "minced", quantity: "2", unit: "clove", category: "produce" },
      { id: uid(), component: "", name: "vegetable stock", prep: "", quantity: "1", unit: "l", category: "pantry" },
      { id: uid(), component: "", name: "cumin", prep: "", quantity: "1", unit: "tsp", category: "spices" },
    ],
    instructions: [
      "Saute the onion and carrots in a pot until softened, about 5 minutes.",
      "Add garlic and cumin, cook 30 seconds until fragrant.",
      "Add lentils and stock, bring to a boil, then simmer 25 minutes until lentils are tender.",
      "Season to taste and serve.",
    ],
  },
  {
    id: uid(), title: "Sheet-pan salmon and veg", cuisine: "American", source: "Generic Seeding", favorite: false, mealTypes: ["dinner"], recipeType: "entree",
    dietTags: ["glutenFree"], seasons: ["Spring"], cookingMethod: [], yield: "", activeTime: 10, cookTime: 15, servings: 2, caloriesPerServing: 410, proteinPerServing: 36, carbsPerServing: 8, fatPerServing: 26,
    ingredients: [
      { id: uid(), component: "", name: "salmon fillets", prep: "whole", quantity: "2", unit: "", category: "protein" },
      { id: uid(), component: "", name: "asparagus", prep: "trimmed", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "lemon", prep: "sliced", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "olive oil", prep: "", quantity: "2", unit: "tbsp", category: "pantry" },
    ],
    instructions: ["Preheat oven to 425°F.", "Arrange salmon and asparagus on a sheet pan, drizzle with olive oil.", "Roast 12-15 minutes until salmon flakes easily.", "Squeeze lemon over top before serving."],
  },
  {
    id: uid(), title: "Weekend pancakes", cuisine: "American", source: "Generic Seeding", favorite: false, mealTypes: ["breakfast"], recipeType: "entree",
    dietTags: ["vegetarian"], seasons: [], cookingMethod: [], yield: "", activeTime: 10, cookTime: 10, servings: 4, caloriesPerServing: 350, proteinPerServing: 10, carbsPerServing: 46, fatPerServing: 13,
    ingredients: [
      { id: uid(), component: "", name: "flour", prep: "", quantity: "2", unit: "cup", category: "pantry" },
      { id: uid(), component: "", name: "eggs", prep: "", quantity: "2", unit: "", category: "dairy" },
      { id: uid(), component: "", name: "milk", prep: "", quantity: "1 1/2", unit: "cup", category: "dairy" },
      { id: uid(), component: "", name: "butter", prep: "melted", quantity: "2", unit: "tbsp", category: "dairy" },
    ],
    instructions: ["Whisk flour, eggs, milk, and melted butter together until just combined.", "Heat a griddle over medium heat.", "Pour 1/4 cup batter per pancake, flip when bubbles form on top.", "Cook another 1-2 minutes until golden."],
  },
  {
    id: uid(), title: "Simple green salad", cuisine: "American", source: "Generic Seeding", favorite: false, mealTypes: ["dinner"], recipeType: "side",
    dietTags: ["vegan", "vegetarian", "glutenFree"], seasons: ["Summer"], cookingMethod: [], yield: "", activeTime: 10, cookTime: 0, servings: 4, caloriesPerServing: 120, proteinPerServing: 2, carbsPerServing: 6, fatPerServing: 10,
    ingredients: [
      { id: uid(), component: "", name: "mixed greens", prep: "washed", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "cucumber", prep: "sliced", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "olive oil", prep: "", quantity: "2", unit: "tbsp", category: "pantry" },
    ],
    instructions: ["Toss greens and cucumber with olive oil.", "Season with salt and pepper to taste."],
  },
  {
    id: uid(), title: "Apple slices with peanut butter", cuisine: "American", source: "Generic Seeding", favorite: false, mealTypes: ["snack"], recipeType: "other",
    dietTags: ["vegan", "vegetarian", "glutenFree"], seasons: ["Fall"], cookingMethod: [], yield: "", activeTime: 5, cookTime: 0, servings: 1, caloriesPerServing: 190, proteinPerServing: 7, carbsPerServing: 20, fatPerServing: 10,
    ingredients: [
      { id: uid(), component: "", name: "apple", prep: "sliced", quantity: "1", unit: "", category: "produce" },
      { id: uid(), component: "", name: "peanut butter", prep: "", quantity: "2", unit: "tbsp", category: "pantry" },
    ],
    instructions: ["Slice the apple.", "Serve with peanut butter for dipping."],
  },
];

export const SEED_RECIPES = RAW_SEED_RECIPES.map((r) => ({
  ...r,
  instructions: r.instructions.map((s) => ({ id: uid(), component: "", type: "step", text: s })),
}));
